import React from 'react'
import { Usa, Uk, Europe, Malaysia, Australia } from '../../../Shared/Images/image';
const services = props =>{
    return(
        <section>
                <div style={{ backgroundColor : " #F2F2F2" }} className="py-5">
                    <div className="ms-width">
                        <h2 className="heading2 font-weight-bold text-center">Our <span className="text-color2">Services</span></h2>
                        <div className="d-flex flex-md-row flex-column pt-5">
                            <div className="flex-fill">
                                <div className="text-center">   
                                    <img src={Uk } alt="usaImage" width="120" height="120" />
                                    <h1 className="heading3 fw-sb text-center mt-2">UK</h1>
                                </div>                        
                            </div>
                            <div className="flex-fill">
                                <div className="text-center">   
                                    <img src={Usa } alt="usaImage" width="120" height="120" />
                                    <h1 className="heading4 fw-sb text-center mt-2">USA</h1>
                                </div>                        
                            </div>
                            <div className="flex-fill">
                                <div className="text-center">   
                                    <img src={ Europe } alt="usaImage" width="120" height="120" />
                                    <h1 className="heading4 fw-sb text-center mt-2">Europe</h1>
                                </div>                        
                            </div>
                        </div>
                        <div className="d-flex flex-md-row flex-column pt-5 px-md-5">
                            <div className="flex-fill">
                                <div className="text-center">   
                                    <img src={ Australia } alt="usaImage" width="120" height="120" />
                                    <h1 className="heading4 fw-sb text-center mt-2">Australia</h1>
                                </div>                        
                            </div>
                            <div className="flex-fill">
                                <div className="text-center">   
                                    <img src={ Malaysia } alt="usaImage" width="120" height="120" />
                                    <h1 className="heading4 fw-sb text-center mt-2">Malaysia</h1>
                                </div>                        
                            </div>
                            
                        </div>
                    </div>
                </div>
        </section>
    )
}

export default services;